<template>
	<inertia-head title="Members" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">View Members Login</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Members Login
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-6">
							<div class="row">
								<div class="col-md-12">
									<div class="mb-4">
										<label for="date" class="form-label">
											Registration Date
										</label>
										<flat-pickr
											v-model="form.date"
											id="date"
											class="form-control form-control-sm"
											:config="{
												altInput: true,
												altFormat: 'M j, Y',
												dateFormat: 'Y-m-d',
												wrap: true,
												mode: 'range',
											}"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="mb-4">
										<label for="" class="form-label">Filter by</label>
										<select
											v-model="form.filterByColumn"
											class="form-select form-select-sm"
										>
											<option value="u.email">Email</option>
											<option value="u.fname">First Name</option>
											<option value="u.lname">Last Name</option>
											<option value="u.counter">User ID</option>
										</select>
									</div>
								</div>
								<div class="col-md-6">
									<div class="mb-4">
										<label for="" class="form-label">Value</label>
										<input
											v-model="form.columnValue"
											type="text"
											class="form-control form-control-sm"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 space-x-1 mb-4 d-flex align-items-end">
							<div class="row">
								<div class="col-12 mb-4">
									<div class="form-check form-switch form-check-inline">
										<input
											@change="toggleShowExpired"
											:value="form.showExpired"
											:checked="form.showExpired"
											class="form-check-input"
											type="checkbox"
											id="show-expired"
										/>
										<label class="form-check-label" for="show-expired">
											Show Expired
										</label>
									</div>
								</div>
								<div class="col-12 space-x-1">
									<button
										type="submit"
										class="btn btn-alt-primary"
										:disabled="form.processing || !form.isDirty"
									>
										Refine Result
									</button>
									<button
										@click="
											$inertia.get(route('admin.user-management.members.index'))
										"
										type="button"
										class="btn btn-alt-secondary"
									>
										Reset
									</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead class="text-center">
							<tr>
								<th>#</th>
								<th>USERID</th>
								<th>LAST LOGIN</th>
								<th>MEMBERSHIP</th>
								<th>EXPIRY</th>
								<th>FULLNAME</th>
								<th>EMAIL</th>
								<th>DATE REGS</th>
							</tr>
						</thead>
						<tbody v-if="members.data.length > 0" class="fs-sm">
							<tr
								v-for="(member, index) in members.data"
								:key="member.counter"
								class="text-center"
							>
								<td>{{ index + members.from }}</td>
								<td>
									<inertia-link
										:href="
											route(
												'admin.user-management.members.show',
												member.member_uuid
											)
										"
										class="fw-semibold text-info"
									>
										{{ member.counter }}
										<i class="fa fa-arrow-right"></i>
									</inertia-link>
								</td>
								<td data-title="Last Login:">{{ member.last_login }}</td>
								<td data-title="Membership:">{{ member.current_rank }}</td>
								<td data-title="Expiry:">{{ member.expiry }}</td>
								<td data-title="Fullname:">{{ member.full_name }}</td>
								<td data-title="Email:">{{ member.email }}</td>
								<td data-title="Date regs:">
									<h6 class="mb-0 fs-xs">{{ member.dateregs }}</h6>
									<small>{{ member.timeregs }}</small>
								</td>
							</tr>
						</tbody>
						<tbody v-else class="fs-sm">
							<tr>
								<th colspan="8" class="text-center">NO RECORD FOUND</th>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="members" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		members: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			date: props.filters.date,
			filterByColumn: props.filters.filterByColumn,
			columnValue: props.filters.columnValue,
			showExpired: props.filters.showExpired === 'false' ? false : true,
		})

		const toggleShowExpired = () => {
			form.showExpired = form.showExpired ? false : true
		}

		const submit = () => {
			form.get(route('admin.user-management.login-tracker'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		return {
			form,
			submit,
			toggleShowExpired,
		}
	},
}
</script>
